import axios from 'axios';

export default function() {

  return {
    email: '',
    location: '',
    ready: false,
    submitted: false,
    submitting: false,
    hasErrors : false,
    msg : '',

    init() {
      this.ready = true;
      this.location = window.location.pathname.replace(/^\/+/, '');
    },

    callback(response) {
      if(response.errors.length) {
        this.hasErrors = true;
        this.msg = 'Sorry, there was an error. Please try again later.';
      }
      else {
        if(response.data.is_subscribed) {
          this.msg = 'Thanks. You are already subscribed to the newsletter.';
        }
        else {
          this.msg = 'Thank you for subscribing.';
        }
      }
      this.submitted = true;
      this.submitting = false;
    },

    submit() {
      if(this.submitting) {
        return;
      }
      if(! this.validate()) {
        return;
      }

      this.msg = '';
      this.hasErrors = false;
      this.submitted = false;
      this.submitting = true;

      let formData = new FormData(this.$root);
      axios.post('https://manage.kmail-lists.com/ajax/subscriptions/subscribe', formData)
        .then(response => this.callback(response.data))
        .catch(err => {
          console.error(err);
        });
    },

    validate() {
      return this.ready && this.email;
    },
  };

}
